import { FC, HTMLAttributes, useState } from "react";
import clsx from "classnames";
import { isIOS, isMobile } from "react-device-detect";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import Logo from "../../../assets/settings/logo.webp";
import Logo2x from "../../../assets/settings/logo@2x.webp";
import Logo3x from "../../../assets/settings/logo@3x.webp";
import Download from "../../../assets/settings/download.webp";
import Download2x from "../../../assets/settings/download@2x.webp";
import Download3x from "../../../assets/settings/download@3x.webp";
import { PopupAddHomeScreen } from "../PopupAddHomeScreen";
import { AndroidAddPwa } from "../AndroidAddPwa";
import { useAppDispatch } from "../../../hooks";
import { addPopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import { isPwaInstalled } from "../../../models/system";
import { getImage3x } from "../../../models/theme";
import { useStyles } from "./PwaBanner.style";
import { useTranslation } from "react-i18next";

export const PwaBanner: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { className, ...otherProps } = props;
  const dispatch = useAppDispatch();
  const [isInstall, setIsInstall] = useState(isPwaInstalled());
  const logo = getImage3x("logo.webp");

  const onGetApp = async () => {
    dispatch(
      addPopupQueue({
        type: isIOS ? PopupType.AddHomeScreen : PopupType.AndroidAddPwa,
      }),
    );
  };

  if (isInstall || !isMobile) return null;

  return (
    <>
      <div
        {...otherProps}
        className={clsx(classes.root, className)}
        onClick={onGetApp}
      >
        <Image
          src={logo?.oneX || Logo}
          src2x={logo?.twoX || Logo2x}
          src3x={logo?.threeX || Logo3x}
        />
        <Typography variant={TypographyVariant.BodyB6Regular}>
          {t("add_ca_to_home_screen_message", {
            appName: import.meta.env.VITE_APP_NAME_ID,
          })}
        </Typography>
        <Image src={Download} src2x={Download2x} src3x={Download3x} />
      </div>
      <PopupAddHomeScreen />
      <AndroidAddPwa setIsInstall={setIsInstall} />
    </>
  );
};
